//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Components",0,"SelectNXObjectList",0],[0,"PackageClearanceTypesModification",1,0],[0,"PackageName",1,0],[0,"PackageNameModification",1,0],[0,"PartNumber",1,0],[0,"PartNumberModification",1,0],[0,"PlacementOwner",1,0],[0,"ReferenceDesignator",1,0],[0,"ReferenceDesignatorModification",1,0]],[[["count"],"GetPackageClearanceTypes",{R_:{data:""}},0,0],[["data"],"SetPackageClearanceTypes",{},1,0]],[]];
SPLM.PcbExchange.ComponentAttributesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.ComponentAttributesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.ComponentAttributesBuilder.PlacementOwnerEnum = Object.freeze({
    "Mcad" : "Mcad", "Ecad" : "Ecad", "Placed" : "Placed", "Unplaced" : "Unplaced"});

export default SPLM;